/* eslint-disable camelcase */
import React from 'react'
import { SwiperSlide } from 'swiper/react'
import { func, object, string, bool, array } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { urlWithTrack } from '../../../helpers/common'
import { EMPTY_OBJECT, EMPTY_ARRAY } from '../../../utils/constants'
import ResponsiveImage from '../../ui/image/ResponsiveImage'
import AdLink from '../../ui/ad-link/AdLink'
import SaveButton from '../../ui/button/SaveButton'
import AdSwiper from '../../ui/ad-swiper/AdSwiper'
import { productMessages as messages } from '../messages'
import Insights from '../Insights'
import { getProductDestinationUrl } from '../../../utils/url_parser'

const Product = ({
  insights = EMPTY_OBJECT,
  item = EMPTY_OBJECT,
  classes = '',
  isBig,
  handleLinkClick,
  images = EMPTY_ARRAY,
  type,
  isProductsView = false,
  gridView,
  scope
}) => {
  const { url, duplicates, featured_images = EMPTY_OBJECT, title, bim = false, company = EMPTY_OBJECT } = item
  const featured_image = featured_images ? isBig ? featured_images.url_large : featured_images.url_medium : ''
  const countryCode = window.AFD && window.AFD.countryCode
  const destinationUrl = getProductDestinationUrl({ url, duplicates }, scope, countryCode)
  const trackedUrl = urlWithTrack(destinationUrl, type)
  const imageProps = {
    large: { src: featured_image },
    small: { src: featured_images.url_medium },
    commonProps: { 'data-object-fit': 'cover' }
  }

  return (
    <Insights className={`gridview__item ${classes}`} {...insights}>
      {bim && <span className='products__bim-label'>BIM</span>}
      {images.length > 1 ? (
        <AdSwiper isLazy>
          {images.map((image, index) => (
            <SwiperSlide lazy='true' key={index}>
              <div className='gridview__image-wrapper'>
                <AdLink href={trackedUrl} onClick={handleLinkClick}>
                  <ResponsiveImage
                    imageProps={{
                      large: { 'src': isBig ? image.url_large : image.url_medium },
                      small: { 'src': image.url_medium },
                      commonProps: {
                        className: 'swiper-lazy',
                        alt: image.image_alt || '',
                        ...(index !== 0 && { loading: 'lazy' }),
                        isBig: isBig
                      }
                    }}
                  />
                </AdLink>
              </div>
            </SwiperSlide>
          ))}
        </AdSwiper>
      )
        : (
          <div className='gridview__image-wrapper'>
            <AdLink href={trackedUrl} onClick={handleLinkClick}>
              <ResponsiveImage imageProps={imageProps} />
            </AdLink>
          </div>
        )
      }

      <SaveButton title={title} image={featured_image} url={destinationUrl} gridView={gridView} insights={insights} />

      <AdLink href={trackedUrl} onClick={handleLinkClick} className='gridview__content'>
        {/* type */}
        <div className='gridview__text'>
          {isProductsView ? company.name : <FormattedMessage {...messages.product} />}
        </div>
        {/* title */}
        <h3 className='gridview__entry-title'>{title}</h3>
      </AdLink>
    </Insights>
  )
}

Product.propTypes = {
  handleLinkClick: func,
  item: object,
  insights: object,
  isBig: bool,
  classes: string,
  images: array,
  type: string,
  isProductsView: bool,
  gridView: bool,
  scope: string
}

export default React.memo(Product)
